import { render } from "./PopupConfirmation.vue?vue&type=template&id=9ac40c04&scoped=true"
import script from "./PopupConfirmation.vue?vue&type=script&lang=js"
export * from "./PopupConfirmation.vue?vue&type=script&lang=js"

import "./PopupConfirmation.vue?vue&type=style&index=0&id=9ac40c04&scoped=true&lang=css"

import exportComponent from "F:\\homework\\tokenza\\tokenza_airdrop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ac40c04"]])

export default __exports__